import React, { useRef, useEffect, useCallback, useState} from 'react';
import {useScrollTo} from './useScrollTo.js';
import {getSoundResultsServer} from './getSoundResults.js';
import ethereum from 'decentralized/ethereum.js';
import PresetIcon from "components/installation/getPresetStyle.js";
import {FILTER_BY_DAY, FILTER_BY_DAY_TAG} from 'constants/contextual-help.js';
import Documented from 'components/help/Documented.js';
import {getBlockDate} from 'utils/getBlockDate.js';
import {INSTRUMENT_TYPE_TO_NAME} from 'constants/instrument-types.js';
import {
    setCurrentTagInList,
    setSampleTagDragging,
    setSamplesDragging} from 'actions/index.js';
import {formatDate} from './formatDate.js';
import Colors from 'components/Colors.js';
import ipfs from 'decentralized/Ipfs.js';
import {connect} from 'react-redux';
const colors = new Colors();
window.tran2 = 0.6;
window.tran = 0.3;

const Day = ({
    results,
    searchTerm,
    onClickDay,
    isCurrent,
    onClickSource,
    number,
    filterFavorites,
    setCurrentTagInList,
    sourceToSearch,
    setSamplesDragging,
    setSourceToSearch,
    setSampleTagDragging,
    scrollRef,
}) => { 
    let ref = useRef(undefined);
    let [dayResults, setDayResults] = useState(results);
    let {tag,  blockNumber, instrumentTypes, discogs, youtube, unsourced, totalResults} = dayResults || {};
    let [date, setDate] = useState(undefined);
    let [toggled, setToggled] = useState(tag === "" || searchTerm !== "" || sourceToSearch);

    useEffect(() => {
        if (results) {
            setDayResults(results);
        }
    }, [results, setDayResults]);

    useEffect(() => {
        if (searchTerm !== "") {
            setToggled(true);
        }
    }, [searchTerm, setToggled]);

    useEffect(() => {
        getBlockDate(blockNumber).then(
            setDate);
    }, [blockNumber]);

    let text = tag !== "" ? tag : date ? formatDate(date) : "";
    let style = {
        backgroundColor: colors.transparent(colors.saturate(colors.getColorForHash(text), 1.2), window.tran2)
    };

    let ratio = Math.pow(totalResults / 30.0, 0.5);
    if (!toggled) {
        style.opacity = ratio;
    }

    useEffect(() => {
        if (unsourced) {
            setToggled(true);
        }
    }, [unsourced, setToggled]);

    const onClick= useCallback(() => {
        setCurrentTagInList(number);
        if (toggled) {
            onClickDay(dayResults, tag);
        } else {
            if (unsourced) {
                setToggled(true);
            } else {
                // need to get results
                getSoundResultsServer(
                    50,
                    searchTerm, 0, "tag", 0, filterFavorites, undefined, tag)
                    .then((r) => {
                        console.log('results gotten for tag=', tag);
                        setDayResults(r[0]);
                    });
            }
        }
    }, [
        onClickDay,
        results,
        tag,
        toggled,
        setToggled,
        setDayResults,
        unsourced,
        dayResults,
        number,
        filterFavorites]);

    useScrollTo({ref, scrollRef, isCurrent, expanded: toggled});

    useEffect(() => {
        if (isCurrent) {
            window.addEventListener("keydown", onKeyDown);
        }
        return () => isCurrent && window.removeEventListener("keydown", onKeyDown);
    }, [isCurrent, onClickDay, results, tag, toggled, setToggled, setDayResults, unsourced, dayResults, number]);

    const onKeyDown = useCallback((e) => {
        if (e.key === 'Enter') {
            onClick();
        }
    }, [isCurrent, onClickDay, results, tag, toggled, setToggled, setDayResults, unsourced, dayResults, number]);

    let className = "day";
    if (toggled) {
        className += " day toggled";
    }
    if (toggled && (!discogs || !unsourced || !youtube)) {
        console.log("RETURNNING toggled=%s", toggled, dayResults, results, discogs, unsourced, youtube);
        return [];
    }
    if (isCurrent) {
        className += " current";
    }
    return (
        <Documented element={FILTER_BY_DAY}>
          <div
            ref={ref} 
            draggable={tag !== "" && searchTerm === ""}
            onDragStart={() => setSampleTagDragging(tag)}
            onDragOver={(e) => e.preventDefault()}
            style={style} className={className} onClick={onClick}>
            <div className="floppy-part">
              <div style={toggled ? style : undefined} className="date">
                {tag !== "" ? tag : date ? formatDate(date) : ""}
              </div>
            </div>
            {!toggled ? <div style={style} className="floppy-inner"/> :
             <div className="sources">
               {Object.keys(discogs).map(
                   (coverArtHash, i) =>
                       <Source
                         i={i}
                         setSourceToSearch={setSourceToSearch}
                         key={coverArtHash}
                         setSamplesDragging={setSamplesDragging}
                         onClickSource={onClickSource}
                         coverArtHash={coverArtHash}
                         results={discogs[coverArtHash]}/>)}
               {Object.keys(youtube).map(
                   (videoId, i) =>
                       <Source
                         i={i}
                         key={videoId}
                         setSamplesDragging={setSamplesDragging}
                         setSourceToSearch={setSourceToSearch}
                         onClickSource={onClickSource}
                         videoId={videoId}
                         results={youtube[videoId]}/>)}
               {Object.keys(unsourced).map(
                   (tag, i) =>
                       <Source
                         i={i}
                         key={tag}
                         setSamplesDragging={setSamplesDragging}
                         onClickSource={onClickSource}
                         instrumentType={unsourced[tag][0].instrumentType}
                         tag={tag}
                         results={unsourced[tag]}/>)}
             </div>}
          </div>
        </Documented>
    );
};

const Source = ({
    setSourceToSearch,
    i,
    results,
    instrumentType,
    coverArtHash,
    videoId,
    tag,
    onClickSource, setSamplesDragging}) => {
        let [userName, setUserName] = useState('');
        useEffect(() => {
            if (results[0] && results[0].user) {
                ethereum.users.getUserName(results[0].user)
                    .then(x => setUserName(x));
            }
        }, []);

        let style = {
        };
        let bookLeftStyle = {
        };

        let color = colors.saturate(
            colors.getColorForHash(coverArtHash && coverArtHash !== '' ? coverArtHash : videoId), 3);
        if (coverArtHash) {
            style.backgroundImage = 'url(' + ipfs.getHashUrl(coverArtHash) + ")";
        } else if (videoId) {
            style.backgroundImage = 'url(' + 'https://img.youtube.com/vi/' + videoId + '/1.jpg)';
        } else {
            if (!instrumentType && !tag) {
                style.display = 'none';
            }
        }
        let _color = instrumentType ?
            colors.saturate(colors.getColorForHash(INSTRUMENT_TYPE_TO_NAME[instrumentType]), 5) :
            tag ? colors.saturate(colors.saturate(colors.getColorForHash(tag), 3), 3) : undefined;
        if (_color) {
            // bookLeftStyle.color = colors.compliment(_color, 1.5); //colors.transparent(color, 0.90);
            color = _color;
        }  else if (color) {
            // bookLeftStyle.color = colors.compliment(color, 1.5); //colors.transparent(color, 0.90);
        }

        let title = coverArtHash && results[0].releaseName ?
            results[0].artistName + '-' + results[0].releaseName :
            coverArtHash ? results[0].title :
            videoId ? results[0].title :
            tag; 
        if (title === '' || title) {
            title = results[0].title;
        }
        let tags = results
            .filter(x => x.tags)
            .map(x => x.tags).reduce((a,b) => [... a, ...b], [])
            .filter(_tag => tag !== _tag && _tag !== 'Resampled');

        let counts = {};
        for (let tag of tags) {
            counts[tag] = tag.length;
        }
        let max = 100;
        let maxTag = tag;
        for (let _tag in counts) {
            if (_tag !== tag && counts[_tag] < max) {
                maxTag = _tag;
                max = counts[_tag];
            }
        }
        let person = results[0].artistName !== '' ?
            results[0].artistName : userName;
        let releaseName = results.find(x => x.releaseName !== '');
        let releaseId = undefined;
        if (releaseName) {
            title = releaseName.releaseName;
            releaseId = releaseName.releaseId;
        }
        if (!coverArtHash && !videoId && coverArtHash != '' && videoId != '') {
            title = tag.toUpperCase();
        }
        tag = maxTag;
        title = Math.floor(i / 20) % 2 === 1 ? cleanTitle(title) : cleanTitle(title);


        color = colors.transparent(color, window.tran);

        let className = " source-container";
        if (coverArtHash) {
            className += " record";
        }

        if (i % 3 == 2 ) {
            className += " bigger";
        }
        
        return (
            <Documented
              arg={title}
              element={FILTER_BY_DAY_TAG}>
              <div
                draggable={true}
                onDragStart={(e) => setSamplesDragging(results.map(x => x.ipfsHash))}
                onDragOver={(e) => e.preventDefault()}
                style={{width: i % 3 < 2 ? 186 : 186*2}}
                onClick={(e) => e.stopPropagation() || onClickSource(e, {results, coverArtHash, videoId, tag})}
                className={className}>
                <div
                  style={bookLeftStyle}
                  className="book-left">
                  <span>
                    {tag && tag !== '' ? tag : instrumentType && results.length === 1 ? results[0].title : INSTRUMENT_TYPE_TO_NAME[instrumentType]}
                  </span>
                </div>
                <div
                  className="source-title">
                  {title}
                </div>
                {coverArtHash || videoId ? 
                 <div
                   onClick={(e) => {
                       e.stopPropagation();
                       if (videoId && videoId !== "") {
                           setSourceToSearch({videoId});
                       } else {
                           setSourceToSearch({releaseId});
                       }
                   }}
                   className="source-thumb" style={style}>
                 </div> : 
                 <div style={bookLeftStyle} className="book-right">{person}</div>}
              </div>
            </Documented>
        );
    };

const Bar = ({length}) => {
    return (
        <div className="bar">
          <div style={{width: Math.min(100 * length / 20, 100) + '%'}} className="bar-indicator">
          </div>
        </div>
    );
};

const mapStateToProps = (state, props) => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setSampleTagDragging: x => dispatch(setSampleTagDragging(x)),
        setSamplesDragging: (s) => dispatch(setSamplesDragging(s)),
        setCurrentTagInList: (s) => dispatch(setCurrentTagInList(s))
    };
};

const cleanTitle = (title) => {
    if (!title) {
        return '';
    }
    title = title.trim();
    title = title.replace(/[|&;$%@"<>()+,]/g, "");
    let t = "";
    for (let i=0; i < title.length; i++) {
        if (title.charCodeAt(i) > 32) {
            return title.substring(i);
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Day);
